import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import {
  DP_DOCUMENTATION_LIST,
  DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA,
  DP_DOCUMENTATION_SEND_INVOICE_EMAIL,
  DP_DOCUMENTATION_SEND_LETTERS_EMAIL
} from '../../actions';
import {
  DocumentationListSuccess,
  DocumentationListError,
  DocumentationInvoiceTemplateDataSuccess,
  DocumentationInvoiceTemplateDataError,
  DocumentationSendInvoiceEmailSuccess,
  DocumentationSendInvoiceEmailError,
  DocumentationSendLettersEmailSuccess,
  DocumentationSendLettersEmailError
} from './actions';

const sendLettersEmail = async (payload) => {
  const token = await authFB.currentUser.getIdToken(true);
  const response = await fetch(`${servicePath}delivery_plan/documentation/send_letters_email`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', token },
    body: JSON.stringify(payload)
  });
  const data = await response.json();

  if (!response.ok || data.status !== true) {
    throw new Error(data.message || 'No fue posible enviar las cartas al proveedor');
  }
  return data;
};

function* onSendLettersEmail({ payload }) {
  try {
    const response = yield call(sendLettersEmail, payload);
    yield put(DocumentationSendLettersEmailSuccess(response, payload.v_delivery_order_reference));
  } catch (error) {
    yield put(DocumentationSendLettersEmailError(error, payload.v_delivery_order_reference));
  }
}

export function* watchSendLettersEmail() {
  yield takeEvery(DP_DOCUMENTATION_SEND_LETTERS_EMAIL, onSendLettersEmail);
}

const getDocumentationList = async (payload) => {
  const token = await authFB.currentUser.getIdToken(true);
  const response = await fetch(`${servicePath}delivery_plan/documentation/list`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', token },
    body: JSON.stringify(payload)
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'No fue posible obtener la lista de documentación');
  }
  return data;
};

function* onDocumentationList({ payload }) {
  try {
    const response = yield call(getDocumentationList, payload);
    yield put(DocumentationListSuccess(response));
  } catch (error) {
    yield put(DocumentationListError(error));
  }
}

const getInvoiceTemplateData = async (payload) => {
  const token = await authFB.currentUser.getIdToken(true);
  const response = await fetch(`${servicePath}delivery_plan/documentation/invoice_template_data`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', token },
    body: JSON.stringify(payload)
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'No fue posible obtener los datos para facturar');
  }
  return data;
};

const sendInvoiceTemplateEmail = async (payload) => {
  const token = await authFB.currentUser.getIdToken(true);
  const response = await fetch(`${servicePath}delivery_plan/documentation/send_invoice_template_email`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', token },
    body: JSON.stringify(payload)
  });
  const data = await response.json();

  if (!response.ok || data.status !== true) {
    throw new Error(data.message || 'No fue posible enviar el correo al proveedor');
  }
  return data;
};

function* onInvoiceTemplateData({ payload }) {
  try {
    const response = yield call(getInvoiceTemplateData, payload);
    yield put(DocumentationInvoiceTemplateDataSuccess(
      response.data || [],
      response.accessoryComplementData || [],
      response.supplierEmailData || [],
      response.sentEmailInfo || null
    ));
  } catch (error) {
    yield put(DocumentationInvoiceTemplateDataError(error));
  }
}

function* onSendInvoiceTemplateEmail({ payload }) {
  try {
    const response = yield call(sendInvoiceTemplateEmail, payload);
    yield put(DocumentationSendInvoiceEmailSuccess(response));
  } catch (error) {
    yield put(DocumentationSendInvoiceEmailError(error));
  }
}

export function* watchInvoiceTemplateData() {
  yield takeEvery(DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA, onInvoiceTemplateData);
}

export function* watchDocumentationList() {
  yield takeEvery(DP_DOCUMENTATION_LIST, onDocumentationList);
}

export function* watchSendInvoiceTemplateEmail() {
  yield takeEvery(DP_DOCUMENTATION_SEND_INVOICE_EMAIL, onSendInvoiceTemplateEmail);
}

export default function* rootSaga() {
  yield all([
    fork(watchDocumentationList),
    fork(watchInvoiceTemplateData),
    fork(watchSendInvoiceTemplateEmail),
    fork(watchSendLettersEmail)
  ]);
}
